import { render } from "./edit-dlivery.vue?vue&type=template&id=2dcdf8be&scoped=true"
import script from "./edit-dlivery.vue?vue&type=script&lang=js"
export * from "./edit-dlivery.vue?vue&type=script&lang=js"

import "./edit-dlivery.vue?vue&type=style&index=0&id=2dcdf8be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dcdf8be"]])

export default __exports__